<template lang="pug">

  section.filter-panel(v-if="controlWithUIPanel.filter")
    .asu-title
      span Filtrar por
    v-tabs(@change="onChange" :value="activeTab" centered icons-and-text slider-color="primary" )
      v-tab(href="#tab-1" :disabled="!state.shapes" class="primary--text") Proyectos
        .icon-button
          i.center.ap-shape
      v-tab-item(value="tab-1" :lazy="true")
        md-list.v-tab-list(:md-expand-single="true" v-if="state.shapes")
          md-list-item(md-expand)
            span.md-list-item-text Tipos
            md-list.filter-by.type(slot="md-expand")
              md-list-item(:key="item.text" v-for="item in types")
                label
                  md-checkbox(v-model="localTypes" :id="item.text" :value="item.text" @change.native="sendToggleType")
                  span {{item.text}}
              md-list-item.buttons
                v-btn(small @click="showAll('Types')") Ver todos
                v-btn(small @click="hideAll('Types')") Ocultar todos
          md-list-item(md-expand)
            span.md-list-item-text Estados
            md-list.filter-by.state(slot="md-expand")
              md-list-item(:key="item.value" v-for="item in status")
                label
                  md-checkbox(v-model="localStatus" :id="item.value" :value="item.value" @change.native="sendToggleStatus")
                  span {{item.text}}
              md-list-item.buttons
                v-btn(small @click="showAll('Status')") Ver todos
                v-btn(small @click="hideAll('Status')") Ocultar todos
          md-list-item(md-expand)
            span.md-list-item-text Ente Ejecutor
            md-list.filter-by.executor(slot="md-expand")
              md-list-item(:key="item.text" v-for="item in executors")
                label
                  md-checkbox(v-model="localExecutors" :id="item.text" :value="item.text" @change.native="sendToggleExecutor")
                  span {{item.text}}
              md-list-item.buttons
                v-btn(small @click="showAll('Executors')") Ver todos
                v-btn(small @click="hideAll('Executors')") Ocultar todos

      v-tab(href="#tab-2" :disabled="!state.refugios" class="primary--text") Albergues
        .icon-button
          i.center.ap-Refuge
      v-tab-item(value="tab-2" :lazy="true")
        md-list(:md-expand-single="true" v-if="state.refugios")
          md-list-item(md-expand)
            span.md-list-item-text Estados
            md-list.filter-by.type(slot="md-expand")
              md-list-item(:key="`refugio-filter-status-${getKeyId(item)}`" v-for="item in refugiosStatus")
                label
                  md-checkbox(v-model="localRefugiosStatus" :id="item" :value="item" @change.native="sendToggleRefugiosStatus")
                  span {{item}}
              md-list-item.buttons
                v-btn(small @click="showAll('RefugiosStatus')") Ver todos
                v-btn(small @click="hideAll('RefugiosStatus')") Ocultar todos
          md-list-item(md-expand)
            span.md-list-item-text Zonas
            md-list.filter-by.type(slot="md-expand")
              md-list-item(:key="`refugio-filter-zonas-${getKeyId(item)}`" v-for="item in refugiosZonas")
                label
                  md-checkbox(v-model="localRefugiosZonas" :id="item" :value="item" @change.native="sendToggleRefugiosZonas")
                  span {{item}}
              md-list-item.buttons
                v-btn(small @click="showAll('RefugiosZonas')") Ver todos
                v-btn(small @click="hideAll('RefugiosZonas')") Ocultar todos
          md-list-item(md-expand)
            span.md-list-item-text Barrios
            md-list.filter-by.type(slot="md-expand")
              md-list-item(:key="`refugio-filter-barrios-${getKeyId(item)}`" v-for="item in refugiosBarrios")
                label
                  md-checkbox(v-model="localRefugiosBarrios" :id="item" :value="item" @change.native="sendToggleRefugiosBarrios")
                  span {{item}}
              md-list-item.buttons
                v-btn(small @click="showAll('RefugiosBarrios')") Ver todos
                v-btn(small @click="hideAll('RefugiosBarrios')") Ocultar todos
        //- FilterRefugioByCenso

      v-tab(href="#tab-3" :disabled="!state.instituciones" class="primary--text") Instituciones
        .icon-button
          i.center.ap-institucion-afectada
      v-tab-item(value="tab-3" :lazy="true")
        md-list(:md-expand-single="true" v-if="state.instituciones")
          md-list-item(md-expand)
            span.md-list-item-text Tipos
            md-list.filter-by.type(slot="md-expand")
              md-list-item(:key="item" v-for="item in institucionesTypes")
                label
                  md-checkbox(v-model="localInstitucionesTypes" :id="item" :value="item" @change.native="sendToggleInstitucionesTypes")
                  span {{item}}
              md-list-item.buttons
                v-btn(small @click="showAll('InstitucionesTypes')") Ver todos
                v-btn(small @click="hideAll('InstitucionesTypes')") Ocultar todos

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { refugioFilterObject, projectFilterObject, institucionesFilterObject } from '@/constants.js'
import { clone } from '@/utils/object.js'
import { lower, spaceToUnderscore } from '@/utils/string-utils.js'

const TAB1 = 'tab-1'
const TAB2 = 'tab-2'
const TAB3 = 'tab-3'

export default {
  name: 'FilterPanel',
  components: {
    FilterRefugioByCenso: _ => import('@/components/map/solucion-a-corto-plazo/FilterByCenso')
  },
  mounted () {
    this.localExecutors = clone(this.projectsFilter.executors)
    this.localStatus = clone(this.projectsFilter.status)
    this.localTypes = clone(this.projectsFilter.types)
    this.localRefugiosStatus = clone(this.refugiosFilter.refugiosStatus)
    this.localRefugiosZonas = clone(this.refugiosFilter.zonas)
    this.localRefugiosBarrios = clone(this.refugiosFilter.barrios)
    this.localInstitucionesTypes = clone(this.institucionesFilter.institucionesTypes)

    this.throttleType = this.throttle(e => {
      this.toggleTypes(e.target.id)
    })
    this.throttleStatus = this.throttle(e => {
      this.toggleStatus(e.target.id)
    })
    this.throttleExecutor = this.throttle(e => {
      this.toggleExecutors(e.target.id)
    })
    this.throttleRefugiosStatus = this.throttle(e => {
      this.toggleRefugiosStatus(e.target.id)
    })
    this.throttleRefugiosZonas = this.throttle(e => {
      this.toggleRefugiosZonas(e.target.id)
    })
    this.throttleRefugiosBarrios = this.throttle(e => {
      this.toggleRefugiosBarrios(e.target.id)
    })
    this.throttleInstitucionesTypes = this.throttle(e => {
      this.toggleInstitucionesTypes(e.target.id)
    })
  },
  data () {
    return {
      executors: projectFilterObject.executors,
      status: projectFilterObject.status,
      types: projectFilterObject.types,
      refugiosStatus: refugioFilterObject.refugiosStatus,
      refugiosZonas: refugioFilterObject.zonas,
      refugiosBarrios: refugioFilterObject.barrios,
      institucionesTypes: institucionesFilterObject.institucionesTypes,
      activeTab: 'tab-1',
      localExecutors: [],
      localStatus: [],
      localTypes: [],
      localRefugiosStatus: [],
      localRefugiosZonas: [],
      localRefugiosBarrios: [],
      localInstitucionesTypes: []
    }
  },
  methods: {
    ...mapActions([
      'desactivateControl',
      'toggleExecutors',
      'toggleStatus',
      'toggleTypes',
      'toggleRefugiosStatus',
      'toggleRefugiosZonas',
      'toggleRefugiosBarrios',
      'toggleInstitucionesTypes',
      'reloadExecutors',
      'reloadStatus',
      'reloadTypes',
      'reloadRefugiosStatus',
      'reloadRefugiosZonas',
      'reloadRefugiosBarrios',
      'reloadInstitucionesTypes',
      'emptyFilterExecutors',
      'emptyFilterStatus',
      'emptyFilterTypes',
      'emptyFilterRefugiosStatus',
      'emptyFilterRefugiosZonas',
      'emptyFilterRefugiosBarrios',
      'emptyFilterInstitucionesTypes'
    ]),
    throttle (fn, threshold = 100) {
      let deferTimer
      let argument = null

      return (event) => {
        argument = event

        if (!deferTimer) {
          deferTimer = setTimeout(() => {
            deferTimer = null
            fn(argument)
          }, threshold)
        }
      }
    },

    sendToggleExecutor (e) {
      this.throttleExecutor(e)
    },
    sendToggleStatus (e) {
      this.throttleStatus(e)
    },
    sendToggleType (e) {
      this.throttleType(e)
    },
    sendToggleRefugiosStatus (e) {
      this.throttleRefugiosStatus(e)
    },
    sendToggleRefugiosZonas (e) {
      this.throttleRefugiosZonas(e)
    },
    sendToggleRefugiosBarrios (e) {
      this.throttleRefugiosBarrios(e)
    },
    sendToggleInstitucionesTypes (e) {
      this.throttleInstitucionesTypes(e)
    },

    onChange (tabIndex) {
      this.activeTab = tabIndex
    },

    showAll (filterName) {
      this[`reload${filterName}`]()
    },

    hideAll (filterName) {
      this[`emptyFilter${filterName}`]()
    },

    getKeyId (item) {
      return lower(spaceToUnderscore(item))
    },

    setActiveTabByState (state) {
      if (state.shapes && !state.refugios && !state.instituciones) {
        this.activeTab = TAB1
      } else if (!state.shapes && state.refugios && !state.instituciones) {
        this.activeTab = TAB2
      } else if (!state.shapes && !state.refugios && state.instituciones) {
        this.activeTab = TAB3
      }
    }
  },
  computed: {
    ...mapGetters(['controlWithUIPanel', 'projectsFilter', 'refugiosFilter', 'institucionesFilter']),
    ...mapGetters({
      state: 'interfaceState'
    })
  },
  watch: {
    projectsFilter (newData) {
      this.localTypes = clone(newData.types)
      this.localStatus = clone(newData.status)
      this.localExecutors = clone(newData.executors)
    },

    refugiosFilter (newData) {
      this.localRefugiosStatus = clone(newData.refugiosStatus)
      this.localRefugiosZonas = clone(newData.zonas)
      this.localRefugiosBarrios = clone(newData.barrios)
    },

    institucionesFilter (newData) {
      this.localInstitucionesTypes = clone(newData.institucionesTypes)
    },

    state (val) {
      this.setActiveTabByState(val)
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'

$tab-button-height = $f78px
$div-aux-to-fixed-header = ($tab-button-height + $f38px)

.filter-panel
  background-color: white
  border-radius: 0.25rem
  margin-left: $f10px
  &.selected
    .filter-by
      max-height: 500px
  .asu-title
    display: inline-block
    box-sizing: border-box
    color: $color_0
    height: $f44px
  .center
    font-size: $f16px
  .v-tabs
    .icon-button
      display: inline-block
      border-radius: 50%
      border: $f1px solid $color_0
      margin-bottom: $f10px
    i
      width: $f40px
      height: $f40px
      font-size: $f25px
      text-align: center
    & >>>
      .v-tab
        padding: 0
      // Estilo para header fixed
      .v-window
        overflow: auto
        padding: 0
        height: "calc(100vmin - %s)" % 19rem
        height: "calc(100vh - %s)" % 19rem
      .v-tabs__container
        height: $tab-button-height
        transform: none !important
        .v-tabs__item
          &.v-tabs__item--active
            font-weight: bold
            .icon-button
              background-color: $color_0
            i
              color: white
          &[disabled]
            .icon-button
              border-color: #ccc
        .v-tabs__div
          min-width: $f95px
          width: $f95px
      .md-content.v-tabs-content.md-theme-default
        border-bottom-right-radius: 0.25rem
        border-bottom-left-radius: 0.25rem
  .md-checkbox.md-theme-default.md-checked >>> .md-checkbox-container
    background-color: $color_0
    border-color: $color_0
  .md-list
    padding: 0
  .md-list-item
    & >>> .md-list-item-content
      padding: 4px 16px
      color: $color_0
    &.buttons
      padding-top: $f10px

.filter-by
  list-style: none
  margin: 0
  padding: $f10px
  label
    display: flex
    align-items: center
    width: 100%
  span
    padding-left: $f5px
    white-space: normal
    color: $color_0
    font-size: $f17px
  input[type]
    background-color: white
    border-radius: 50%
    vertical-align: middle
    outline: none
    cursor: pointer
    &:checked
      background-color: gray
  & >>> .md-checkbox
    margin: 0 $f5px 0 $f15px
    .md-checkbox-container
      width: $f16px
      min-width: $f16px
      height: $f16px
      margin: 0
</style>
